export default "__VITE_ASSET__nhugYRUm__"